import {IReviewForm, IReviewFormData, IOverallRating, IReview, INotify} from './reviewForm.types';
import { AppConstants as _app } from '@/shared/app.constants';

export class ReviewForm implements IReview {
    public override: boolean;
    public language: string;
    public templateList: any;
    public usedTemplate: any;
    public reviews: Array<IReviewFormData>;
    public totalScore: number;
    public recommendation: any;
    public overallRating: number;
    public comment: string;
    public reviewerId: any;
    public applicationId: any;
    public _id: string;
    public version: string;
    public status: number;
    public notification: INotify;
    public auditInfo: any;
    public reviewId: number;
    constructor(data: any){
        this.reviews = data.reviews;
        this.totalScore = data.totalScore;
        this.recommendation = data.recommendation;
        this.overallRating = data.overallRating;
        this._id = data._id;
        this.version = data.version;
        this.status = data.status;
        this.reviewerId = data.reviewerId;
        this.applicationId = data.applicationId;
        this.comment = data.comment;
        this.override = data.override;
        this.templateList = data.templateList;
        this.usedTemplate = data.usedTemplate;
        this.language = data.language || localStorage.getItem("language") || _app.workspace.default_lang;
        this.notification = data.notification;
        this.auditInfo = data.auditInfo;
        this.reviewId = data.reviewId;
    }
    calculatedRating() {
        let sum = 0;
        this.reviews.map((item: IReviewFormData) => {
            sum += item.rating;
        });
        this.totalScore = sum;
    }
    
}